import type { ThemeTokens } from '@/shared/ui/theme/tokens';

interface CountdownBarProps {
  seconds: number;
  color: string;
  T: ThemeTokens;
}

export function CountdownBar({ seconds, color, T }: CountdownBarProps) {
  return (
    <div
      style={{
        width: '100%',
        height: 6,
        borderRadius: 6,
        background: T.border,
        overflow: 'hidden',
        marginTop: 10,
      }}
    >
      <div
        style={{
          height: '100%',
          borderRadius: 6,
          background: color,
          animation: `mi-countdown-shrink ${seconds}s linear forwards`,
        }}
      />
    </div>
  );
}
